import {InjectionToken} from '@angular/core';
import {Abilities} from '@casl/ability';
import {AccessManagementConfig} from '@scalified-monorepo/shared/casl';

export const ACCESS_MANAGEMENT_CONFIG = new InjectionToken<AccessManagementConfig<Abilities>>(
  'scalified-monorepo/access-management-config'
);
